module.exports = __webpack_public_path__ + "media/audio8.f8081945.wav";